import React from "react";
import { Link } from "react-router-dom";
import Site2Layout from "./Site2Layout";

const CONTACT_CARDS = [
  {
    icon: "📞",
    label: "Phone",
    lines: [
      { text: "+91 8605373028", href: "tel:+918605373028" },
      { text: "+91 9623074249", href: "tel:+919623074249" },
    ],
  },
  {
    icon: "✉️",
    label: "Email",
    lines: [
      { text: "tarakglobal@gmail.com", href: "mailto:tarakglobal@gmail.com" },
      { text: "thayyilramesh9@gmail.com", href: "mailto:thayyilramesh9@gmail.com" },
    ],
  },
  {
    icon: "📍",
    label: "Address",
    lines: [
      { text: "A/212, Vora Plaza, Near Ambaji Mandir, Navghar," },
      { text: "Vasai Road East, Via. Mumbai," },
      { text: "Maharashtra, India — 401210" },
    ],
  },
];

const SOCIAL_LINKS = [
  {
    icon: (
      <svg className="w-5 h-5 text-[#481F57]" fill="currentColor" viewBox="0 0 24 24">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    ),
    label: "Tarak Global Enterprises",
    sublabel: "Company Page",
    href: "https://www.linkedin.com/company/tarak-global-enterprises/",
  },
  {
    icon: (
      <svg className="w-5 h-5 text-[#481F57]" fill="currentColor" viewBox="0 0 24 24">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
      </svg>
    ),
    label: "Ramesh Achuthan Thayyil",
    sublabel: "CEO & Founder",
    href: "https://www.linkedin.com/in/ramesh-achuthan-thayyil-12a93422/",
  },
];

const Site2Contact = () => (
  <Site2Layout
    tag="Reach Out"
    title="Get in Touch"
    subtitle="Looking to set up your business in India or expand globally? We are your trusted partners."
  >
    <section style={{ backgroundColor: "#ffffff" }} className="py-20 px-6">
      <div className="max-w-5xl mx-auto">

        {/* Contact cards */}
        <div className="grid md:grid-cols-3 gap-6 mb-14">
          {CONTACT_CARDS.map((c, i) => (
            <div
              key={i}
              style={{ background: "#f9fafb", border: "1px solid rgba(72, 31, 87, 0.12)" }}
              className="rounded-2xl p-6 text-center shadow-sm"
            >
              <span className="text-3xl block mb-3">{c.icon}</span>
              <p style={{ color: "#481F57" }} className="text-xs font-bold tracking-widest uppercase mb-3">
                {c.label}
              </p>
              {c.lines.map((line, j) =>
                line.href ? (
                  <a
                    key={j}
                    href={line.href}
                    className="block text-gray-800 text-sm font-semibold leading-7 hover:text-[#481F57] hover:underline transition-all"
                  >
                    {line.text}
                  </a>
                ) : (
                  <p key={j} className="text-gray-700 text-sm leading-6">
                    {line.text}
                  </p>
                )
              )}
            </div>
          ))}
        </div>

        {/* Social / LinkedIn */}
        <div className="mb-14">
          <h2 className="text-xl font-bold text-[#481F57] mb-6 text-center">Connect on LinkedIn</h2>
          <div className="grid sm:grid-cols-2 gap-4 max-w-2xl mx-auto">
            {SOCIAL_LINKS.map((s, i) => (
              <a
                key={i}
                href={s.href}
                target="_blank"
                rel="noreferrer"
                style={{
                  background: "#ffffff",
                  border: "1px solid rgba(72, 31, 87, 0.12)",
                }}
                className="rounded-2xl p-5 flex items-center gap-4 hover:shadow-md hover:border-[#481F57] transition-all group text-left"
              >
                <span>{s.icon}</span>
                <div>
                  <p className="text-gray-900 font-bold text-sm group-hover:text-[#481F57] transition-colors">
                    {s.label}
                  </p>
                  <p className="text-gray-500 text-xs font-semibold">{s.sublabel}</p>
                </div>
                <span className="ml-auto text-gray-400 group-hover:text-[#481F57] transition-colors text-lg">↗</span>
              </a>
            ))}
          </div>
        </div>

        {/* CTA strip */}
        <div
          style={{
            background: "linear-gradient(135deg, #f5f3ff, #fae8ff)",
            border: "1px solid rgba(72, 31, 87, 0.15)",
          }}
          className="rounded-2xl p-10 text-center"
        >
          <h2 className="text-2xl lg:text-3xl font-extrabold text-[#481F57] mb-3">
            Ready to grow together?
          </h2>
          <p className="text-gray-600 mb-7 max-w-lg mx-auto leading-7">
            Drop us a message and we'll get back to you to discuss how we can support
            your growth ambitions.
          </p>
          <a
            href="mailto:tarakglobal@gmail.com"
            style={{ background: "linear-gradient(135deg,#481F57,#6B3080)" }}
            className="inline-block text-white font-bold px-8 py-4 rounded-full hover:opacity-90 transition-opacity shadow-md"
          >
            Send us an Email
          </a>
        </div>

      </div>
    </section>
  </Site2Layout>
);

export default Site2Contact;
